// Login
export const LOGIN_SET_DATA = "LOGIN_SET_DATA";
export const LOGIN_ON_LOGOUT = "LOGIN_ON_LOGOUT";

// Extracted Dumps
export const EXTRACTED_DUMPS_SET_ITEMS = "EXTRACTED_DUMPS_SET_ITEMS";
export const EXTRACTED_DUMPS_SET_FILTERS = "EXTRACTED_DUMPS_SET_FILTERS";

// Calls
export const CALLS_SET_ITEMS = "CALLS_SET_ITEMS";
export const CALLS_SET_FILTERS = "CALLS_SET_FILTERS";

// Raw Packets
export const RAW_PACKETS_SET_ITEMS = "RAW_PACKETS_SET_ITEMS";
export const RAW_PACKETS_SET_FILTERS = "RAW_PACKETS_SET_FILTERS";

// Files
export const FILES_SET_ITEMS = "FILES_SET_ITEMS";
export const FILES_SET_FILTERS = "FILES_SET_FILTERS";